import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'conversationForbiddenTitle'
	| 'conversationForbiddenDescription'
	| 'conversationHistoryLoadFailedTitle'
	| 'conversationHistoryLoadFailedDescription'
	| 'autoConversationPrompt';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		conversationForbiddenTitle: {
			id: 'ai-mate.conversation-assistant.flag.conversation-forbidden.title',
			defaultMessage: 'This conversation is not available',
			description:
				'Title for the flag shown when a user tries to open a conversation they do not have permission to view',
		},
		conversationForbiddenDescription: {
			id: 'ai-mate.conversation-assistant.flag.conversation-forbidden.description',
			defaultMessage:
				'The conversation you tried to open may belong to another user or you may not have permission to view it.',
			description:
				'Description for the flag shown when a user tries to open a conversation they do not have permission to view',
		},
		conversationHistoryLoadFailedTitle: {
			id: 'ai-mate.conversation-assistant.flag.conversation-history-load-failed.title',
			defaultMessage: "We couldn't load your conversations",
			description:
				'Title for the flag shown when Rovo chat cannot load the conversation history list',
		},
		conversationHistoryLoadFailedDescription: {
			id: 'ai-mate.conversation-assistant.flag.conversation-history-load-failed.description',
			defaultMessage:
				'You can keep chatting with Rovo, but your conversation history may be out of date.',
			description:
				'Description for the flag shown when Rovo chat cannot load the conversation history list but the user can keep using chat',
		},
		autoConversationPrompt: {
			id: 'ai-mate.conversation-assistant.auto-conversation.prompt',
			defaultMessage:
				'Hey Rovo, list three things you can do with my work that will make me more effective this week.',
			description: 'Prompt for the auto conversations experiment',
		},
	});

export default message;
